import React from 'react';
import PropTypes from 'prop-types';

import {
  HOUR_VIEW_KEYS,
  showRegularHours,
  showOTHours,
  showDoubleOTHours,
} from './timeTrackingGrid.constants';
import { formatDisplayHours, roundHours } from './timeTrackingGridHelpers';

export default function TimeTrackingGridSummaryCell({
  datum,
  type,
  selectedView,
}) {
  if (type === 'equipment') {
    return (
      <div className="time-tracking-grid-summary-cell">
        <div className="time-tracking-grid-summary-cell-line">
          <span className="time-tracking-grid-summary-cell-hours">{roundHours(datum.hours).toFixed(2)}</span>
          <span className="time-tracking-grid-summary-cell-hours-unit">h</span>
        </div>
      </div>
    );
  }

  return (
    <div className="time-tracking-grid-summary-cell">
      {showRegularHours(selectedView) && (
        <div className="time-tracking-grid-summary-cell-line" key="reg">
          <span className="time-tracking-grid-summary-cell-hours">{formatDisplayHours(datum.hours)}</span>
          <span className="time-tracking-grid-summary-cell-hours-unit">REG</span>
        </div>
      )}
      {showOTHours(selectedView) && (
        <div className="time-tracking-grid-summary-cell-line" key="ot">
          <span className="time-tracking-grid-summary-cell-hours">{formatDisplayHours(datum.otHours)}</span>
          <span className="time-tracking-grid-summary-cell-hours-unit">OT</span>
        </div>
      )}
      {showDoubleOTHours(selectedView) && (
        <div className="time-tracking-grid-summary-cell-line" key="dt">
          <span className="time-tracking-grid-summary-cell-hours">{formatDisplayHours(datum.doubleOTHours)}</span>
          <span className="time-tracking-grid-summary-cell-hours-unit">DT</span>
        </div>
      )}
    </div>
  );
}

TimeTrackingGridSummaryCell.propTypes = {
  datum: PropTypes.shape({
    hours: PropTypes.number.isRequired,
    otHours: PropTypes.number.isRequired,
    doubleOTHours: PropTypes.number.isRequired,
  }).isRequired,
  type: PropTypes.string.isRequired,
  selectedView: PropTypes.oneOf(HOUR_VIEW_KEYS),
};

TimeTrackingGridSummaryCell.defaultProps = {
  selectedView: 'All',
};
